// extracted by mini-css-extract-plugin
module.exports = {"featureComparisonTable":"style-module__featureComparisonTable___3fmGm"};